import React from "react";
import { motion } from "framer-motion";
const animations = {
  initial: {
    opacity: 0,
    oveflow: "hidden",
  },
  animate: {
    opacity: 1,
    oveflow: "hidden",
  },
  exit: {
    opacity: 0,
    oveflow: "hidden",
  },
};
const AnimatedPages = ({ children }) => {
  return (
    <motion.div
      variants={animations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.6 }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPages;
